
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: 'hotspot-plain-spot',
})

export default class extends Vue {
  @Prop({default: {}, required: true}) private spot: object;

  private closeSpot(): void {
    this.$parent['activeSpot'] = null;

    const fullScreenEl = document.getElementsByClassName('fullscreen__overlay').length ? document.getElementsByClassName('fullscreen__overlay')[0] : null;
    if (fullScreenEl) {
      fullScreenEl.classList.remove('--visible');
    }
  }

  private get imageSrc(): null | string {
    if ( ! this.spot['details']['image']) {
      return null;
    }

    return `${this.$solarCdnBaseUrl}/cdn/resize-extended/rs:fill/w:${this.spot['details']['image']['width']}/h:${this.spot['details']['image']['height']}/extend:true/path${this.spot['details']['image']['location']}`;
  }
}
